function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M221.337,177.333c-10.797,0-16.682,12.755-16.682,28.865c-0.198,16.279,6.077,28.648,16.682,28.648 c11.396,0,16.483-12.171,16.483-29.039C237.813,190.292,233.311,177.333,221.337,177.333z"
})), React.createElement("g", null, React.createElement("path", {
  d: "M154.59,152.996c0-15.52-4.521-28.475-16.492-28.475c-10.785,0-16.492,12.76-16.492,28.862 c-0.393,16.282,5.702,28.655,16.492,28.655C149.486,182.038,154.59,169.869,154.59,152.996z"
})), React.createElement("g", null, React.createElement("path", {
  d: "M359.981,191.528l-29.333-33.359l17.81-36.059l-35.843-17.678l2.805-43.547l-44.46-2.858l-13.45-39.74l-38.449,13.027 L191.529,0L159.04,28.567L119.774,9.172l-18.762,37.978l-40.115-2.564L58.25,85.802L15.942,100.13l14.187,41.859L0.012,168.467 l26.316,29.931L6.83,237.886l40.413,19.948l-2.657,41.288l39.623,2.547l13.571,40.04l42.073-14.243l28.61,32.527l30.778-27.076 l36.269,17.907l18.892-38.274l44.711,2.882l2.738-42.862l37.494-12.694l-13.103-38.659L359.981,191.528z M107.87,153.975 c0-25.511,13.934-39.856,30.819-39.856c17.861,0,29.637,13.754,29.637,38.097c0,26.889-14.129,40.232-30.615,40.232 C121.804,192.441,108.065,179.69,107.87,153.975z M147.511,246.04h-10.986l74.988-131.928h11.001L147.511,246.04z M220.94,245.26 c-15.9,0-29.651-12.755-29.838-38.274c0-25.734,13.938-40.062,30.816-40.062c17.876,0,29.454,13.736,29.454,38.073 C251.373,231.911,237.249,245.26,220.94,245.26z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgOfertas = function SvgOfertas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "359.993px",
    height: "359.993px",
    viewBox: "0 0 359.993 359.993",
    style: {
      enableBackground: "new 0 0 359.993 359.993"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOfertas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ofertas.646a92c4.svg";
export { ForwardRef as ReactComponent };